import postcss from 'postcss';
import prefixSelector from 'postcss-prefix-selector';

export const scopeCSS = async (
  htmlContent: string,
  prefix: string = '#scoped-db-content'
): Promise<string> => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  const styleTags: any = tempDiv.querySelectorAll('style');

  for (const styleTag of styleTags) {
    const css = styleTag.innerHTML;
    if (!css) continue;

    const result = await postcss([
      prefixSelector({
        prefix,
        transform(prefix: any, selector: any, prefixedSelector: any) {
          if (selector.startsWith('@')) return selector;
          return `${prefix} ${selector}`;
        },
      }),
    ]).process(css, { from: undefined });

    styleTag.innerHTML = result.css;
  }

  return tempDiv.innerHTML;
};
